module.exports = __webpack_public_path__ + "media/site/images/carousel_slides/carousel-slide-intro-startups-bg-6888495caf7610ebcd3245c7fb6a647b.png";